import { useState } from "react";
import axios from "axios";
import "./SubscriptionForm.css"; // You'll need to create this CSS file

const SubscriptionForm = () => {
  const [email, setEmail] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState('');

  const API_URL = process.env.REACT_APP_BACKEND_BASEURL || 'http://localhost:5000';

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      setError('Please enter an email address');
      return;
    }
    
    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError('Please enter a valid email address');
      return;
    }
    
    setIsSubmitting(true);
    setError('');
    
    try {
      // Changed to match API structure - note the /api/ prefix
      await axios.post(`${API_URL}/api/subscribe2`, { email });
      
      setIsSubmitted(true);
      setEmail('');
    } catch (error) {
      console.error('Error:', error);
      
      // Better error handling with specific messages
      if (error.response) {
        // Server responded with an error status
        if (error.response.status === 400) {
          setError('This email is already subscribed.');
        } else if (error.response.status === 404) {
          setError('Subscription service not found.');
        } else {
          setError(error.response.data.message || 'Server error occurred.');
        }
      } else if (error.request) {
        // Request was made but no response received
        setError('No response from server. Please check your connection.');
      } else {
        setError('Error subscribing. Please try again later.');
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const openModal = () => {
    setIsModalOpen(true);
    setError('');
    setIsSubmitted(false);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setError('');
  };

  return (
    <div className="blog-subscribe-box">
      <h3 className="blog-subscribe-title">Get the latest blog updates in your inbox</h3>
      <button className="blog-subscribe-button" onClick={openModal}>
        Subscribe
      </button>

      {isModalOpen && (
        <div className="blog-modal-overlay">
          <div className="blog-modal-content">
            <button className="blog-modal-close" onClick={closeModal}>&times;</button>
            <h3 className="blog-modal-title">Get the Blog updates in your inbox!</h3>
            
            {!isSubmitted ? (
              <form onSubmit={handleSubmit}>
                <div className="blog-form-group">
                  <label htmlFor="email" className="blog-form-label">* Email Address:</label>
                  <input
                    type="email"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="blog-form-input"
                    placeholder="Enter your email address"
                    required
                  />
                </div>
                
                {error && <p className="blog-error-message">{error}</p>}
                
                <p className="blog-privacy-note">
                  By registering, you agree to the processing of your personal data as described in the{' '}
                  <a href="/privacy-policy" className="blog-privacy-link">privacy policy</a>.
                </p>
                
                <button 
                  type="submit" 
                  className="blog-submit-button"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Submitting...' : 'Submit'}
                </button>
              </form>
            ) : (
              <div className="blog-success-message">
                <p>Thank you! You have been subscribed successfully.</p>
                <button className="blog-close-button" onClick={closeModal}>
                  Close
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default SubscriptionForm;